import Vue from 'vue'


Vue.filter('addBaseUrl', url=>{
	return url?`https://jianghe.uchar.cn/website${url}`:''
	//return `http://192.168.0.192:8080/website${url}`
})




// WEBPACK FOOTER //
// ./src/service/filter.js